import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonStandaloneModule } from '../../../shared/common-standalone.module';

@Component({
  selector: 'app-shepherd-step-counter',
  templateUrl: './shepherd-step-counter.component.html',
  styleUrls: ['./shepherd-step-counter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonStandaloneModule, TranslateModule],
})
export class ShepherdStepCounterComponent {
  @Input() stepNumber: number;
  @Input() stepCount: number;
}
